<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="redballWidth" colspan="35" class="border-right">红球区域</th>
          <th colspan="18" class="border-right">蓝球区域</th>
        </tr>
        <tr class="title-number">
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, rindex) in lotteryNumbHead" :key="rindex + 'red'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, bindex) in lotteryNumbHead.slice(0,16)" :key="bindex + 'blue'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 红球区域 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'rednum'" v-for="(num, nindex) in redballTableList[index]">
            <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num.toString() }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 蓝球区域 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:32px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="bindex + 'bluenum'" v-for="(num, bindex) in blueballTableList[index]">
              <i class="ball-noraml openNo paddssqb" v-if="num === 'A'">{{ lotteryNumbHead[bindex] ? lotteryNumbHead[bindex].toString().padStart(2, '0') : '' }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="index" v-for="(count, index) in redballStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" v-for="(total, sindex) in blueballStatisticaList.countArr" :key="sindex + 'total'">
            <i class="ball-noraml">{{ total }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="amindex" v-for="(averageMiss, amindex) in redballStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tamindex + 'averageMissArr'" v-for="(totalAverageMiss, tamindex) in blueballStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ totalAverageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="mmindex" v-for="(maxMiss, mmindex) in redballStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tmmindex + 'maxMissArr'" v-for="(totalMaxMiss, tmmindex) in blueballStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ totalMaxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="mcindex" v-for="(maxContinuity, mcindex) in redballStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tmcindex + 'maxContinuity'" v-for="(totalMaxContinuity, tmcindex) in blueballStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ totalMaxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'SsqChart',
  mixins: [mix],
  data() {
    return {
      blueballNumbHead: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
    }
  },
  computed: {
    redballArr() {
      let list = []
      this.lotteryTrendList.forEach(obj => {
        list.push(obj.drawingNumber.split(',').slice(0, -1))
      })
      return list
    },
    redballTableList() {
      return this.chartList(this.redballArr)
    },
    blueballArr() {
      return this.openNumSperateArr[6] ? this.openNumSperateArr[6].map(e => Number(e)) : []
    },
    blueballTableList() {
      return this.chartTotalList(this.blueballNumbHead, this.blueballArr) || []
    },
    redballStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.redballTableList)
    },
    blueballStatisticaList() {
      return this.statistica(this.blueballNumbHead,this.blueballTableList)
    }
  },
  mounted() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      console.log(69999999999999);
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  methods: {
    drawCanvas() {
      let coordinateList = this.getChartCoordinate(this.blueballTableList);
      if(!coordinateList) {
        return;
      }
      if(!this.$refs.trendCanvas) {
        return;
      }
      const ctx = this.$refs.trendCanvas.getContext("2d");
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#455ee9";
      for (let i = 0, len = coordinateList.length; i + 1 < len; i++) {
        ctx.moveTo(coordinateList[i][0], coordinateList[i][1]);
        ctx.lineTo(coordinateList[i + 1][0], coordinateList[i + 1][1]);
      }
      ctx.stroke();
    },
    getChartCoordinate(Coordinate) {
      if (!this.$refs.drawnumbHead) return [];
      let len = Coordinate.length;
      if (len == 0) return [];
      let chartCoordinate = [];
      //获取坐标系
      //先获取表格左边不需要折线部分的宽度
      let dwidth = this.$refs.drawnumbHead.offsetWidth;
      let pwidth = this.$refs.periodsHead.offsetWidth;
      let ntwidth = this.$refs.redballWidth.offsetWidth;
      let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
      let leftCountWidth = dwidth + pwidth + ntwidth; // 左边总宽度
      //每个数据表格td宽度 表格td高度
      if(!document.getElementById("smallRect")) {
        return;
      }
      const tdWidth = document.getElementById("smallRect").offsetWidth;
      const tdHeight = document.getElementById("smallRect").offsetHeight;
      for (let i = 0; i < len; i++) {
        let numb = Number(this.blueballNumbHead[Coordinate[i].indexOf("A")]);
        let index = this.blueballNumbHead.indexOf(numb);
        let x = leftCountWidth + 5 + (tdWidth * index + ( tdWidth / 2));
        let y = topCountWidth + (tdHeight * i + (tdHeight / 2));
        chartCoordinate.push([x, y]);
      }
      return chartCoordinate;
    },
  }
}
</script>

<style>

</style>